import { FlowStepTypes } from './utils/flow-step-types.enum';
import {Canvas} from "../../../../shared/utils/nodeTypes";

export class FlowDetails {
  description: string;
  stepType: FlowStepTypes;
  nodeType: string;
  stepNumber: string;
  nodeId: string;
  horizontalPosition: number;
  verticalPosition: number;
  parentId: string;
  canvas: Canvas;
  displayType: string;
  isExisting: boolean;
  title: string

  constructor(
    description: string,
    stepType: FlowStepTypes,
    nodeType: string,
    stepNumber: string,
    nodeId: string,
    horizontalPosition: number,
    verticalPosition: number,
    parentId: string,
    canvas: Canvas,
    displayType: string,
    isExisting: boolean,
    title: string
  ) {
    this.description = description;
    this.stepType = stepType;
    this.nodeType = nodeType;
    this.stepNumber = stepNumber;
    this.nodeId = nodeId;
    this.horizontalPosition = horizontalPosition;
    this.verticalPosition = verticalPosition;
    this.parentId = parentId;
    this.canvas = canvas;
    this.displayType = displayType;
    this.isExisting = isExisting;
    this.title = title;
  }

  // this.cssExisting = this.cssClass?.indexOf('Existing') !== -1 ? ' existing-node-background' : ''
}

export class NodeDetails {
  description: string;
  stepType: FlowStepTypes;
  nodeType: string;
  nodeId: string;
  canvas: Canvas;
  title: string

  constructor(description: string, stepType: FlowStepTypes, nodeType: string, nodeId: string, canvas: Canvas, title: string) {
    this.description = description;
    this.stepType = stepType;
    this.nodeType = nodeType;
    this.nodeId = nodeId;
    this.canvas = canvas;
    this.title = title;
  }
}

export class FlowBuilder {
  nodeDetails: NodeDetails;
  nextSteps: NextStepDetails[];

  constructor(nodeDetails: NodeDetails, nextSteps: NextStepDetails[]) {
    this.nodeDetails = nodeDetails;
    this.nextSteps = nextSteps;
  }
}

export class NextStepDetails {
  description: string;
  nextStepId: string;

  constructor(description: string, nextStepId: string) {
    this.description = description;
    this.nextStepId = nextStepId;
  }
}

export type OperationType = 'COPY' | 'CUT' | 'DELETE' | 'RESTORE';

export interface OperationState {
  id: string;
  parentId?: string;
  operationType: OperationType;
  data: OperationData;
}

export interface OperationData {
  from?: any;
  to?: any;
  value?: any;
  all?: boolean;
}

export interface DeleteTreeNode {
  expandable: boolean;
  step: FlowDetails;
  level: number;
  isExpanded?: boolean;
}

export interface DeleteStepData {
  stepId: string;
  parentId: string;
}

export interface DeleteNodeItem {
  id: string;
  index: number;
}
